import React, { useEffect, useState } from "react";
import GooglePlaceAutoComplete from "../../../components/common/GooglePlaceAutoComplete";
import Layout from "../../../components/global/layout";
import "react-datetime/css/react-datetime.css";
// import PhoneInput from 'react-phone-input-2'
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import environment from "../../../environment";
import ApiClient from "../../../methods/api/apiClient";
import { PiCheckSquareOffsetFill } from "react-icons/pi";
import { GiLightningFrequency } from "react-icons/gi";
import { MdHomeRepairService } from "react-icons/md";
import { BiSolidStopwatch } from "react-icons/bi";
import { FaMapLocation } from "react-icons/fa6";
import {
  Link,
  useParams,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import loader from "../../../methods/loader";
import addressModel from "../../../models/address.model";
import ReactDatePicker from "react-datepicker";
import methodModel from "../../../methods/methods";
import Layout2 from "../../../components/global/layout2";
import { SiOrigin } from "react-icons/si";
import { FaChartLine } from "react-icons/fa";
import { MdOutlineDriveFileRenameOutline } from "react-icons/md";
import { PiPencilSimpleLineFill } from "react-icons/pi";
import { MdDescription } from "react-icons/md";
import { RiTempHotLine } from "react-icons/ri";
import MarketRateSuggestion from '../../../components/common/MarketRateSuggestion';

const Html = ({
  role,
  form,
  handleSubmit,
  setform,
  addressResult,
  submitted,
  back,
  Stops,
  SetStops,
  arriveStops,
  ArriveSetStops,
  detail,
}) => {
  const history = useHistory();
  const [DisbaledInput, setDisabledInput] = useState(false);
  const user = useSelector((state) => state.user);
  const [boards, setBoards] = useState([]);
  const { id, statusData } = useParams();
  const [num, setnum] = useState(1);
  const [arrivenum, setarrivenum] = useState(1);
  const [data, setdata] = useState([]);
  useEffect(() => {
    if (form?.board_id == environment.uspsId) {
      setDisabledInput(true)
    }
  }, [form?.board_id])
  const AddTag = () => {
    Stops.push({
      stop_nass: "",
      stop_name: "",
      address: "",
      stop_city: "",
      stop_state: ""
    });
    SetStops([...Stops]);
  };
  console.log(Stops, "stop_city")
  const AddAriveStopTag = () => {
    arriveStops.push({
      arrive_stop: "",
      arrive_DayOffset: ""
    });
    ArriveSetStops([...arriveStops]);
  };


  const removetag = (index) => {
    SetStops([...Stops.filter((itm, i) => i != index)]);
    setform({
      ...form,
      stops: [...Stops.filter((itm, i) => i != index)],
    });

    setnum(num - 1);
  };

  const removeAriveStoptag = (index) => {
    ArriveSetStops([...arriveStops.filter((itm, i) => i != index)]);
    setform({
      ...form,
      arriveStops: [...arriveStops.filter((itm, i) => i != index)],
    });

    setarrivenum(num - 1);
  };

  const updatetag = (index, key, value) => {
    console.log(value, "value")
    let arr = Stops;
    arr[index][key] = value;
    SetStops([...arr]);
    setform({
      ...form,
      stops: [...arr],
      // no_of_reservation: arr.length,
    });
    setnum(arr.length);

  };

  const updateArriveStoptag = (index, key, value) => {
    console.log(value, "arrivevalue")
    let arr = arriveStops;
    console.log(arr, "array")
    arr[index][key] = value;
    ArriveSetStops([...arr]);
    setform({
      ...form,
      arriveStops: [...arr],
      // no_of_reservation: arr.length,
    });

    setarrivenum(arr.length);
  };

  useEffect(() => {
    ApiClient.get("boards").then((res) => {
      let filter = res?.data?.data?.filter(
        (itm) => itm?.id != environment.uspsId
      );
      setBoards(filter);
    });
  }, [data]);

  const DestinationAddress = async (e) => {
    let address = {};
    if (e.place) {
      address = await addressModel.getAddress2(e.place);
    }
    setform({
      ...form,
      destination_address: e.value || "",
      destination_location_city: address.city || "",
      destination_location_state: address.state || "",
      destination_location_country: address.country || "",
      destination_location_postal_code: address.zipcode || "",
      // lat: `${address.lat}` || '',
      // lng: `${address.lng}` || ''
    });
  };

  const StopAddress = async (e, index) => {
    let address = {};
    if (e.place) {
      address = await addressModel.getAddress2(e.place);
    }
    let arr = Stops;
    arr[index].address = e.value || "",
      arr[index].stop_city = address.city || "",
      arr[index].stop_state = address.state || "",

      SetStops([...arr]);
    setform({
      ...form,
      stops: [...arr],
      // no_of_reservation: arr.length,
    });

  };



  useEffect(() => {
    loader(true);
    setTimeout(() => {
      loader(false);
    }, 1000);
  }, []);

  const parsedDate = form?.arriveTime ? new Date(form.arriveTime) : null;
  const isValidDate = parsedDate instanceof Date && !isNaN(parsedDate);
  console.log(form?.arriveTime, "arriveTime")
  const parsedDepatureDate = form?.departure_time ? new Date(form.departure_time) : null;
  const isValidDepatureDate = parsedDepatureDate instanceof Date && !isNaN(parsedDepatureDate);

  const parsedStartDate = form?.load_start_date ? new Date(form?.load_start_date) : null;
  const isValidStartDate = parsedStartDate instanceof Date && !isNaN(parsedStartDate);
  const parsedEndDate = form?.load_end_date ? new Date(form.load_end_date) : null;
  const isValidEndDate = parsedEndDate instanceof Date && !isNaN(parsedEndDate);

  return (
    <>
      <Layout2 title={statusData || "Load"}>
        <div className="mainareas">
          <form onSubmit={handleSubmit}>
            <div className=" edit-page-common new-edit edit-page-commons">
              <div className="row">
                <div className="col-lg-12">
                  <div class=" title-head">
                    <h3
                      className="ViewUseraa mb-3 user-back"
                      onClick={() => {
                        history.goBack();
                      }}
                    >
                      <i
                        className="fa fa-arrow-left me-2 "
                        title="Back"
                        aria-hidden="true"
                      ></i>
                      {id ? "Edit" : "Add"} {statusData}
                    </h3>
                  </div>
                </div>
              </div>
              <div class="row">
                <div className="col-xl-12">
                  <div className="row">
                    <div className="col-lg-12 height-set">
                      <div class=" white-head mb-3">
                        <h5 class="profilelist">Basic Information</h5>
                      </div>
                      <div class=" white-bg-main mb-4">
                        <div className="row">

                          <div className="col-md-6 mb-3">
                            <label>
                              Customer Name{" "}
                              <span className="text-danger">*</span>
                            </label>

                            <div className="input-new-design">
                              <div className="input-icon">
                                <i className="fa fa-user"></i>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                value={form.customer_name}
                                required
                                onChange={(e) =>
                                  setform({
                                    ...form,
                                    customer_name: e.target.value,
                                  })
                                }
                                disabled={DisbaledInput}
                              />
                            </div>
                            {submitted && !form.customer_name ? (
                              <div className="invalid-feedback d-block">
                                Customer Name is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>

                          {form?.board_id == environment?.contractId &&
                            <>
                              <div className="col-md-6 mb-3">
                                <label>
                                  Line of Travel{" "}
                                  <span className="text-danger">*</span>
                                </label>

                                <div className="input-new-design">
                                  <div className="input-icon">

                                    <FaChartLine />

                                  </div>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={form.lineTreavel}
                                    required
                                    onChange={(e) =>
                                      setform({
                                        ...form,
                                        lineTreavel: e.target.value,
                                      })
                                    }
                                    disabled={DisbaledInput}
                                  />
                                </div>
                                {submitted && !form.lineTreavel ? (
                                  <div className="invalid-feedback d-block">
                                    Line of travel is Required
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </>
                          }

                          <div class="col-12">
                            <div className="row">
                              {form?.board_id == environment.rfpsId && (
                                <div className="col-md-12 mb-3 ">
                                  <label>
                                    {" "}
                                    Lane ID
                                    <span className="text-danger">*</span>
                                  </label>

                                  <div className="input-new-design">
                                    <div className="input-icon">
                                      <i class="fas fa-hand-point-down"></i>
                                    </div>
                                    <input
                                      type="text"
                                      pattern="^[a-zA-Z0-9]+$"
                                      onKeyPress={(e) => {
                                        var regex = new RegExp(
                                          "^[a-zA-Z0-9]+$"
                                        );
                                        var key = String.fromCharCode(
                                          !e.charCode ? e.which : e.charCode
                                        );
                                        if (!regex.test(key)) {
                                          e.preventDefault();
                                          return false;
                                        }
                                      }}
                                      required
                                      className="form-control"
                                      value={form?.lane_id}
                                      onChange={(e) =>
                                        setform({
                                          ...form,
                                          lane_id: e.target.value,
                                        })
                                      }
                                      disabled={DisbaledInput}
                                    />
                                  </div>
                                  {submitted && !form?.lane_id ? (
                                    <div className="invalid-feedback d-block">
                                      Lane ID is Required
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              )}

                              {!(form?.board_id == environment.rfpsId) && (
                                <div className="col-md-6 mb-3 ">
                                  <label className=" d-block">
                                    Load ID
                                    <span className="text-danger">*</span>
                                  </label>
                                  <div className="input-new-design">
                                    <div className="input-icon">
                                      <i class="fas fa-file"></i>
                                    </div>
                                    <div className="w-100 d-inline-flex">
                                      <input
                                        type="text"
                                        className="form-control w-100"
                                        pattern="^[a-zA-Z0-9!@#$%^&*_+`~_-]*$"
                                        onKeyPress={(e) => {
                                          var regex = new RegExp(
                                            "^[a-zA-Z0-9]+$"
                                          );
                                          var key = String.fromCharCode(
                                            !e.charCode ? e.which : e.charCode
                                          );
                                          if (!regex.test(key)) {
                                            e.preventDefault();
                                            return false;
                                          }
                                        }}
                                        required
                                        value={form?.load_id}
                                        maxLength={20}
                                        minLength={1}
                                        onChange={(e) =>
                                          setform({
                                            ...form,
                                            load_id: e.target.value,
                                          })
                                        }
                                        disabled={DisbaledInput}
                                      />
                                    </div>
                                    {submitted && !form.load_id ? (
                                      <div className="invalid-feedback d-block">
                                        Load ID is Required
                                      </div>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </div>
                              )}
                              {form?.board_id == environment?.contractId &&
                                <div className="col-md-6 mb-3">
                                  <label>
                                    Type
                                  </label>
                                  <div className="input-new-design">
                                    <div className="input-icon">
                                      <PiPencilSimpleLineFill />
                                    </div>
                                    <input
                                      className="form-control w-100"
                                      pattern="^[a-zA-Z]+$"
                                      onKeyPress={(e) => {
                                        var regex = new RegExp(
                                          "^[a-zA-Z]+$"
                                        );
                                        var key = String.fromCharCode(
                                          !e.charCode ? e.which : e.charCode
                                        );
                                        if (!regex.test(key)) {
                                          e.preventDefault();
                                          return false;
                                        }
                                      }}
                                      id=""
                                      value={form?.type}
                                      onChange={(e) => {
                                        setform({
                                          ...form,
                                          type: e.target.value,
                                        });
                                      }}
                                      disabled={DisbaledInput}
                                    />
                                  </div>


                                </div>
                              }


                              {form?.board_id == environment.uspsId && (
                                <div className="col-md-6 mb-3">

                                  {submitted && !form?.load_end_date ? (
                                    <div className="invalid-feedback d-block">
                                      End Date is Required
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12 height-set">
                      <div class=" white-head mb-3">
                        <h5 class="profilelist">Address</h5>
                      </div>
                      <div class=" white-bg-main mb-4">
                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <label htmlFor="" className="d-flex m-0">
                              {" "}
                              Load Start Date
                              <label className="text-danger d-block">*</label>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-calendar"></i>
                              </div>
                              <div className="w-100 start-load">
                                <ReactDatePicker
                                  selected={isValidStartDate && parsedStartDate != 'Invalid Date' ? parsedStartDate : null}

                                  minDate={Date.now()}
                                  onKeyDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    setform({ ...form, load_start_date: e, load_end_date: "", departure_time: "", arriveTime: "" });
                                  }}
                                  className="form-control w-100 custom-datepicker"
                                  dateFormat="dd-MM-yyyy"
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={70}
                                  showMonthDropdown
                                  dropdownMode="select"
                                />
                              </div>


                            </div>
                            {submitted && !form?.load_start_date ? (
                              <div className="invalid-feedback d-block">
                                Load Start Date is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>

                          {form?.board_id == environment?.contractId && <>
                            {/* <div className="col-md-6 mb-3">
                            <label>
                              Origin NASS{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <SiOrigin />
                              </div>
                              <div className="width-set">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={form.origin_nass}
                                  required
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      origin_nass: e.target.value,
                                    })
                                  }
                                  disabled={DisbaledInput}
                                />
                              </div>
                            </div>
                            {submitted && !form?.origin_nass ? (
                              <div className="invalid-feedback d-block">
                                Origin NASS is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div> */}
                            <div className="col-md-6 mb-3">
                              <label>
                                Origin Name<span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <PiPencilSimpleLineFill />


                                </div>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                  id=""
                                  value={form?.origin_name}
                                  required
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      origin_name: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />
                              </div>

                              {submitted && !form?.origin_name ? (
                                <div className="invalid-feedback d-block">
                                  Origin Name is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </>}

                          <div className="col-md-6 mb-3">
                            <label>
                              Origin Location{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-address-book"></i>
                              </div>
                              <div className="width-set">
                                <GooglePlaceAutoComplete
                                  key="Map1"
                                  value={form?.origin_address}
                                  name={"origin"}
                                  result={addressResult}
                                  required
                                  id="address1"
                                  placeholder=""
                                  disabled={DisbaledInput}
                                />
                              </div>
                            </div>
                            {submitted && !form?.origin_address ? (
                              <div className="invalid-feedback d-block">
                                Origin Location is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>
                              Origin City<span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-building"></i>
                              </div>
                              <input
                                type="text"
                                name=""
                                className="form-control"
                                id=""
                                value={form?.origin_location_city}
                                required
                                onChange={(e) => {
                                  setform({
                                    ...form,
                                    origin_location_city: e.target.value,
                                  });
                                }}
                                disabled={DisbaledInput}
                              />
                            </div>

                            {submitted && !form?.origin_location_city ? (
                              <div className="invalid-feedback d-block">
                                City is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>
                              Origin State<span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-globe-asia"></i>
                              </div>
                              <input
                                type="text"
                                name=""
                                className="form-control"
                                id=""
                                required
                                value={form?.origin_location_state}
                                onChange={(e) => {
                                  setform({
                                    ...form,
                                    origin_location_state: e.target.value,
                                  });
                                }}
                                disabled={DisbaledInput}
                              />
                            </div>

                            {submitted && !form?.origin_location_state ? (
                              <div className="invalid-feedback d-block">
                                State is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>

                          <div className="col-md-6 mb-3">
                            <label>
                              Origin Zipcode
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-map-pin"></i>
                              </div>
                              <input
                                pattern="^[a-zA-Z0-9]+$"
                                onKeyPress={(e) => {
                                  var regex = new RegExp("^[a-zA-Z0-9]+$");
                                  var key = String.fromCharCode(
                                    !e.charCode ? e.which : e.charCode
                                  );
                                  if (!regex.test(key)) {
                                    e.preventDefault();
                                    return false;
                                  }
                                }}
                                min={0}
                                type="number"
                                name=""
                                className="form-control"
                                id=""
                                required
                                value={form?.origin_location_postal_code}
                                onChange={(e) => {
                                  setform({
                                    ...form,
                                    origin_location_postal_code: e.target.value,
                                  });
                                }}
                                disabled={DisbaledInput}
                              />
                            </div>

                            {submitted && !form?.origin_location_state ? (
                              <div className="invalid-feedback d-block">
                                Pincode is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>

                          <div className="col-md-12 mb-3">
                            <label htmlFor="" className="d-flex m-0">
                              {" "}
                              Load End Date
                              <label className="text-danger d-block">*</label>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-calendar"></i>
                              </div>
                              <div className="w-100 start-load">
                                <ReactDatePicker
                                  selected={isValidEndDate && parsedEndDate != 'Invalid Date' ? parsedEndDate : null}
                                  minDate={form?.load_start_date || new Date()}
                                  onKeyDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    setform({ ...form, load_end_date: e });
                                  }}
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control w-100 custom-datepicker"
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={70}
                                  showMonthDropdown
                                  dropdownMode="select"
                                />
                              </div>


                            </div>
                            {submitted && !form?.load_end_date ? (
                              <div className="invalid-feedback d-block">
                                Load End Date is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>

                          {form?.board_id == environment?.contractId && <>
                            {/* <div className="col-md-6 mb-3"> */}
                            {/* <label>
                              Destination NASS{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <SiOrigin />
                              </div>
                              <div className="width-set">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={form.destination_nass}
                                  required
                                  onChange={(e) =>
                                    setform({
                                      ...form,
                                      destination_nass: e.target.value,
                                    })
                                  }
                                  disabled={DisbaledInput}
                                />
                              </div>
                            </div>
                            {submitted && !form?.destination_nass ? (
                              <div className="invalid-feedback d-block">
                                Destination NASS is Required
                              </div>
                            ) : (
                              <></>
                            )} */}
                            {/* </div> */}
                            <div className="col-md-6 mb-3">
                              <label>
                                Destination Name<span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <PiPencilSimpleLineFill />
                                </div>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                  id=""
                                  value={form?.destination_name}
                                  required
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      destination_name: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />
                              </div>

                              {submitted && !form?.destination_name ? (
                                <div className="invalid-feedback d-block">
                                  Destination Name is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </>}

                          <div className="col-md-6 mb-3">
                            <label>
                              Destination Location{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-address-book"></i>
                              </div>
                              <div className="width-set">
                                <GooglePlaceAutoComplete
                                  key="Map2"
                                  value={form?.destination_address}
                                  result={DestinationAddress}
                                  required
                                  id="address2"
                                  placeholder=""
                                  disabled={DisbaledInput}
                                />
                              </div>
                            </div>
                            {submitted && !form?.destination_address ? (
                              <div className="invalid-feedback d-block">
                                Destination Location is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>
                              Destination City{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-building"></i>
                              </div>
                              <input
                                type="text"
                                name=""
                                className="form-control"
                                id=""
                                required
                                value={form?.destination_location_city}
                                onChange={(e) => {
                                  setform({
                                    ...form,

                                    destination_location_city: e.target.value,
                                  });
                                }}
                                disabled={DisbaledInput}
                              />
                            </div>
                            {submitted && !form?.destination_location_city ? (
                              <div className="invalid-feedback d-block">
                                City is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>
                              Destination State{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-globe-asia"></i>
                              </div>
                              <input
                                type="text"
                                name=""
                                className="form-control"
                                id=""
                                required
                                value={form?.destination_location_state}
                                onChange={(e) => {
                                  setform({
                                    ...form,
                                    destination_location_state: e.target.value,
                                  });
                                }}
                                disabled={DisbaledInput}
                              />
                            </div>
                            {submitted && !form?.destination_location_state ? (
                              <div className="invalid-feedback d-block">
                                State is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                          <div className="col-md-6 mb-3">
                            <label>
                              Destination Zipcode{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-map-pin"></i>
                              </div>
                              <input
                                type="number"
                                name=""
                                className="form-control"
                                pattern="^[a-zA-Z0-9]+$"
                                onKeyPress={(e) => {
                                  var regex = new RegExp("^[a-zA-Z0-9]+$");
                                  var key = String.fromCharCode(
                                    !e.charCode ? e.which : e.charCode
                                  );
                                  if (!regex.test(key)) {
                                    e.preventDefault();
                                    return false;
                                  }
                                }}
                                id=""
                                required
                                value={form?.destination_location_postal_code}
                                onChange={(e) => {
                                  setform({
                                    ...form,
                                    destination_location_postal_code:
                                      e.target.value,
                                  });
                                }}
                                disabled={DisbaledInput}
                              />
                            </div>

                            {submitted &&
                              !form?.destination_location_postal_code ? (
                              <div className="invalid-feedback d-block">
                                Zipcode is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Market Rate Suggestion */}
                {form?.origin_location_postal_code && form?.destination_location_postal_code && (
                  <div className="col-md-12 mb-3">
                    <MarketRateSuggestion
                      originZip={form?.origin_location_postal_code}
                      destinationZip={form?.destination_location_postal_code}
                      onRateSelect={(rate) => {
                        if (form?.board_id == environment.rfpsId) {
                          setform({ ...form, all_in_rate: rate });
                        } else {
                          setform({ ...form, bid_rate: rate });
                        }
                      }}
                    />
                  </div>
                )}

                {DisbaledInput && form?.stops?.length == 0 ? <></> : <div className="col-xl-12">
                  <div className=" white-head mb-3 d-flex justify-content-between align-items-center">
                    <h5 class="profilelist mb-0">Stop Details</h5>
                    <div>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={AddTag}
                        disabled={(Stops?.length == 3 || DisbaledInput) && form?.board_id == environment.contractId}
                      >
                        <i class="fa fa-plus mr-2" aria-hidden="true"></i>Add
                        Stop
                      </button>
                    </div>
                  </div>
                  <div className="white-bg-main mb-4">
                    <div className="row">
                      <div className="col-md-12 mb-3">


                        <div className="row">
                          {Stops.map((itm, i) => {
                            return (
                              <div
                                className={`${Stops?.length > 1 ? "col-md-12" : "col-md-12"
                                  }  mb-3`}
                                onChange={(e) => {
                                  if (num > data[0]?.sizeOfVenue) {
                                    removetag(i);
                                  }
                                }}
                                disabled={DisbaledInput}
                              >
                                <div className="row">

                                  {form?.board_id == environment?.contractId && <>
                                    {/* <div className="col-md-6 mb-3">
                                      <label>
                                        Stop NASS
                                      </label>
                                      <div className="input-new-design">
                                        <div className="input-icon">
                                          <SiOrigin />
                                        </div>
                                        <div className="width-set">
                                          <input
                                            type="text"
                                            name=""
                                            className="form-control"
                                            id={`StopsAddress${i}`}
                                            value={itm?.stop_nass}
                                            onChange={(e) => {
                                              updatetag(i, "stop_nass", e.target.value);
                                            }}
                                            disabled={DisbaledInput}
                                          />
                                        </div>
                                      </div>

                                    </div> */}
                                    <div className="col-md-6 mb-3">
                                      <label>
                                        Stop Name
                                        {/* <span className="text-danger">*</span> */}
                                      </label>
                                      <div className="input-new-design">
                                        <div className="input-icon">
                                          <PiPencilSimpleLineFill />
                                        </div>
                                        <input
                                          type="text"
                                          name=""
                                          className="form-control"
                                          id={`StopsAddress${i}`}
                                          value={itm?.stop_name}
                                          // required
                                          onChange={(e) => {
                                            updatetag(i, "stop_name", e.target.value);
                                          }}
                                          disabled={DisbaledInput}
                                        />
                                      </div>

                                    </div>
                                  </>}

                                  <div className="col-md-6 mb-3">
                                    <label>
                                      Address
                                      {/* <span className="text-danger">*</span> */}
                                    </label>
                                    <div className="input-new-design">
                                      <div className="input-icon">
                                        <i class="fas fa-address-book"></i>
                                      </div>
                                      <div className="width-set">
                                        <GooglePlaceAutoComplete
                                          key={`Stop${i}`}
                                          value={itm?.address}
                                          name={"origin"}
                                          result={async (e) => {
                                            StopAddress(e, i);
                                            updatetag(i, "address", e.value);
                                          }}
                                          id={`StopsAddress${i}`}
                                          // required
                                          placeholder=""
                                          disabled={DisbaledInput}
                                        />
                                      </div>
                                    </div>

                                  </div>

                                  {form?.board_id == environment?.contractId && <>
                                    <div className="col-md-6 mb-3" >
                                      <label>
                                        Stop City{" "}
                                        {/* <span className="text-danger">*</span> */}
                                      </label>
                                      <div className="input-new-design">
                                        <div className="input-icon">
                                          <i class="fas fa-building"></i>
                                        </div>
                                        <input
                                          type="text"
                                          name=""
                                          className="form-control"
                                          id={`StopsAddress${i}`}
                                          // required
                                          value={itm?.stop_city}
                                          onChange={(e) => {
                                            updatetag(i, "stop_city", e.target.value);
                                          }}
                                          disabled={DisbaledInput}
                                        />
                                      </div>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                      <label>
                                        Stop State{" "}
                                        {/* <span className="text-danger">*</span> */}
                                      </label>

                                      <div className="input-new-design">
                                        <div className="input-icon">
                                          <i class="fas fa-globe-asia"></i>
                                        </div>
                                        <input
                                          type="text"
                                          name=""
                                          className="form-control"
                                          id={`StopsAddress${i}`}
                                          // required
                                          value={itm?.stop_state}
                                          onChange={(e) => {
                                            updatetag(i, "stop_state", e.target.value);
                                          }}
                                          disabled={DisbaledInput}
                                        />
                                      </div>
                                    </div>
                                  </>}
                                  <div className="col-md-6">
                                    {Stops?.length > 1 ? (
                                      <button className="delete-btn-red  ms-2 mt-4"
                                        disabled={DisbaledInput}
                                        type="button"
                                      >
                                        <i
                                          className="fa fa-trash text-danger"
                                          onClick={(e) => removetag(i)}

                                        ></i>
                                      </button>
                                    ) : (
                                      ""
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </div>


                    </div>



                    {detail &&
                      detail.role &&
                      detail.role._id == "6540cfa35a7513892be61415" ? (
                      <div className="col-md-6 mb-3">
                        <label>Merchant Fee (%)</label>
                        <input
                          className="form-control"
                          type="number"
                          // onKeyPress={e=>methodModel.isNumber(e)}
                          value={form.merchant_fee}
                          onChange={(e) => {
                            setform({ ...form, merchant_fee: e.target.value });
                          }}
                          disabled={DisbaledInput}
                        />
                      </div>
                    ) : null}


                  </div>
                </div>}


                {/* Arivel Stops */}

                {form?.board_id == environment?.contractId &&
                  <>
                    {DisbaledInput && form?.arriveStops?.length == 0 ? <></> : <div className="col-xl-12">
                      <div className=" white-head mb-3 d-flex justify-content-between align-items-center">
                        <h5 class="profilelist mb-0">Arrive Stop Details</h5>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={AddAriveStopTag}
                            disabled={(arriveStops?.length == 3 || DisbaledInput) && form?.board_id == environment.contractId}
                          >
                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>Add
                            Arrive Stop
                          </button>
                        </div>
                      </div>
                      <div className="white-bg-main mb-4">
                        <div className="row">
                          <div className="col-md-12 mb-3">


                            <div className="row">
                              {arriveStops.map((itm, i) => {
                                return (
                                  <div
                                    className={`${arriveStops?.length > 1 ? "col-md-12" : "col-md-12"
                                      }  mb-3`}
                                    onChange={(e) => {
                                      if (arrivenum > data[0]?.sizeOfVenue) {
                                        removeAriveStoptag(i);
                                      }
                                    }}
                                    disabled={DisbaledInput}
                                  >
                                    <div className="row">
                                      <div className="col-md-6">
                                        <label>
                                          Arrive Stop{" "}
                                          {/* <span className="text-danger">*</span> */}
                                        </label>
                                        <div className="input-new-design">
                                          <div className="input-icon">
                                            <BiSolidStopwatch />
                                          </div>
                                          <input
                                            type="text"
                                            name=""
                                            className="form-control"
                                            id={`ArriveStopsAddress${i}`}
                                            // required
                                            value={itm?.arrive_stop}
                                            onChange={(e) => {
                                              updateArriveStoptag(i, "arrive_stop", e.target.value);
                                            }}
                                            disabled={DisbaledInput}
                                          />
                                        </div>
                                      </div>
                                      <div className="col-md-6">
                                        <div className="d-flex">
                                          <div className="w-100">
                                            <label>
                                              Arrive Stop Day Offset{" "}
                                              {/* <span className="text-danger">*</span> */}
                                            </label>
                                            <div className="input-new-design">
                                              <div className="input-icon">
                                                <PiCheckSquareOffsetFill />
                                              </div>
                                              <input
                                                type="text"
                                                name=""
                                                className="form-control"
                                                id={`ArriveStopsAddress${i}`}
                                                // required
                                                value={itm?.arrive_DayOffset}
                                                onChange={(e) => {
                                                  updateArriveStoptag(i, "arrive_DayOffset", e.target.value);
                                                }}
                                                disabled={DisbaledInput}
                                              />
                                            </div>
                                          </div>
                                          <div className="pt-[3px]">
                                            {arriveStops?.length > 1 ? (
                                              <button className="delete-btn-red  ms-2 mt-4"
                                                disabled={DisbaledInput}
                                              >
                                                <i
                                                  className="fa fa-trash text-danger pointer"
                                                  onClick={(e) => removeAriveStoptag(i)}

                                                ></i>
                                              </button>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    }
                  </>
                }


                {/* ************** */}

                {form?.board_id ? (
                  <div className=" col-xl-12">
                    <div className=" white-head mb-3">
                      <h5 class="profilelist">Load Details</h5>
                    </div>
                    <div className="white-bg-main mb-4">
                      <div className="row">

                        {form?.board_id == environment.rfpsId && (
                          <div className="col-md-6 mb-3">
                            <label>
                              Average Weight of the load
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-weight"></i>
                              </div>
                              <input
                                type="text"
                                name=""
                                // min={0}
                                // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                className="form-control"
                                value={form?.total_weight}
                                required
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  const regex = /^\d*\.?\d{0,2}$/;
                                  if (
                                    regex.test(inputValue) ||
                                    inputValue === ""
                                  ) {
                                    setform({
                                      ...form,
                                      total_weight: inputValue,
                                    });
                                  }
                                }}
                                disabled={DisbaledInput}
                              />


                              {submitted && !form?.total_weight ? (
                                <div className="invalid-feedback d-block">
                                  Weight is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        )}
                        {form?.board_id == environment.rfpsId && (
                          <div className="col-md-6 mb-3">
                            <label>
                              Capacity<span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-vector-square"></i>
                              </div>
                              <input
                                type="text"
                                // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                // min={0}
                                name=""
                                className="form-control"
                                id=""
                                value={form?.capacity}
                                required
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  const regex = /^\d*\.?\d{0,2}$/;
                                  if (
                                    regex.test(inputValue) ||
                                    inputValue === ""
                                  ) {
                                    setform({
                                      ...form,
                                      capacity: inputValue,
                                    });
                                  }
                                }}
                                disabled={DisbaledInput}
                              />


                              {submitted && !form?.capacity ? (
                                <div className="invalid-feedback d-block">
                                  Capacity is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        )}
                        {form?.board_id == environment.rfpsId && (
                          <div className="col-md-6 mb-3">
                            <label>EST Volume Based on Frequency</label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-vector-square"></i>
                              </div>
                              <input
                                type="text"
                                // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                // min={0}
                                name=""
                                className="form-control"
                                id=""
                                value={form?.est_volume}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  const regex = /^\d*\.?\d{0,2}$/;
                                  if (
                                    regex.test(inputValue) ||
                                    inputValue === ""
                                  ) {
                                    setform({
                                      ...form,
                                      est_volume: inputValue,
                                    });
                                  }
                                }}
                                disabled={DisbaledInput}
                              />
                            </div>
                          </div>
                        )}
                        {form?.board_id == environment.rfpsId || form?.board_id == environment?.contractId && (
                          <div className="col-md-6 mb-3">
                            <label>
                              Frequency
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <GiLightningFrequency />
                              </div>
                              <input
                                type="text"
                                // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                // min={0}
                                name=""
                                required
                                className="form-control"
                                id=""
                                value={form?.frequency}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  const regex = /^\d*\.?\d{0,2}$/;
                                  if (
                                    regex.test(inputValue) ||
                                    !inputValue
                                  ) {
                                    setform({
                                      ...form,
                                      frequency: inputValue,
                                    });
                                  }
                                }}
                                disabled={DisbaledInput}
                              />

                            </div>
                            {submitted && !form?.frequency ? (
                              <div className="invalid-feedback d-block">
                                Frequency is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        )}
                        {form?.board_id == environment?.contractId &&
                          <>
                            <div className="col-md-6 mb-3">
                              <label>
                                Arrive Destination<span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <i class="fas fa-building"></i>
                                </div>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                  id=""
                                  value={form?.arrive_destination}
                                  required
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      arrive_destination: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />
                              </div>

                              {submitted && !form?.arrive_destination ? (
                                <div className="invalid-feedback d-block">
                                  Arrive  Destination  is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Destination Arrival Day Offset<span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <PiCheckSquareOffsetFill />
                                </div>
                                <input
                                  type="text"
                                  name=""
                                  className="form-control"
                                  id=""
                                  value={form?.arrive_destinationDayOffset}
                                  required
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      arrive_destinationDayOffset: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />
                              </div>

                              {submitted && !form?.arrive_destinationDayOffset ? (
                                <div className="invalid-feedback d-block">
                                  Destination Arrival Day Offset is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Perpetual Frequency
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <i class="fas fa-vector-square"></i>
                                </div>
                                <input
                                  type="text"
                                  // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                  // min={0}
                                  name=""
                                  required
                                  className="form-control"
                                  id=""
                                  value={form?.perpetual_frequency}
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      perpetual_frequency: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />


                                {submitted && !form?.perpetual_frequency ? (
                                  <div className="invalid-feedback d-block">
                                    Perpetual Frequency is Required
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Frequency Description
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <MdDescription />
                                </div>
                                <input
                                  type="text"
                                  // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                  // min={0}
                                  name=""
                                  required
                                  className="form-control"
                                  id=""
                                  value={form?.frequency_description}
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      frequency_description: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />


                                {submitted && !form?.frequency_description ? (
                                  <div className="invalid-feedback d-block">
                                    Frequency Description is Required
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Departure Time
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <i class="fas fa-history"></i>
                                </div>
                                <ReactDatePicker
                                  selected={isValidDepatureDate && parsedDepatureDate != 'Invalid Date' ? parsedDepatureDate : null}
                                  minDate={form?.load_start_date}
                                  onKeyDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    setform({ ...form, departure_time: e, arriveTime: "" });
                                  }}
                                  showTimeSelect
                                  className="form-control w-100 custom-datepicker"
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={70}
                                  showMonthDropdown
                                  dropdownMode="select"
                                  dateFormat="dd-MM-yyyy h:mm a"
                                />


                              </div>
                              {submitted && !form?.departure_time ? (
                                <div className="invalid-feedback d-block">
                                  Departure Time is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Arrive Time
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <i class="fas fa-history"></i>
                                </div>
                                <ReactDatePicker
                                  selected={isValidDate && parsedDate != 'Invalid Date' ? parsedDate : null} // fallback to now if invalid

                                  minDate={form?.departure_time}
                                  onKeyDown={(e) => {
                                    e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    setform({ ...form, arriveTime: e });
                                  }}
                                  showTimeSelect
                                  className="form-control w-100 custom-datepicker"
                                  showYearDropdown
                                  scrollableYearDropdown
                                  yearDropdownItemNumber={70}
                                  showMonthDropdown
                                  dropdownMode="select"
                                  dateFormat="dd-MM-yyyy h:mm a"
                                />


                              </div>
                              {submitted && !form?.arriveTime ? (
                                <div className="invalid-feedback d-block">
                                  Arrive Time is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>

                            <div className="col-md-6 mb-3">
                              <label>
                                Avg MPH
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <RiTempHotLine />
                                </div>
                                <input
                                  type="text"
                                  // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                  // min={0}
                                  name=""
                                  required
                                  className="form-control"
                                  id=""
                                  value={form?.avg_mph}
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      avg_mph: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />


                                {submitted && !form?.avg_mph ? (
                                  <div className="invalid-feedback d-block">
                                    Avg MPH is Required
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Miles
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <FaMapLocation />
                                </div>
                                <input
                                  type="text"
                                  // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                  // min={0}
                                  name=""
                                  required
                                  className="form-control"
                                  id=""
                                  value={form?.miles}
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      miles: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />


                                {submitted && !form?.miles ? (
                                  <div className="invalid-feedback d-block">
                                    Miles is Required
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Travel Time Allotted
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <i class="fas fa-history"></i>
                                </div>
                                <input
                                  type="text"
                                  // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                  // min={0}
                                  name=""
                                  required
                                  className="form-control"
                                  id=""
                                  value={form?.travel_time}
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      travel_time: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />


                                {submitted && !form?.travel_time ? (
                                  <div className="invalid-feedback d-block">
                                    Travel Time is Required
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Type of Service
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <MdHomeRepairService />
                                </div>
                                <input
                                  type="text"
                                  // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                  // min={0}
                                  name=""
                                  required
                                  className="form-control"
                                  id=""
                                  value={form?.service_type}
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      service_type: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />


                                {submitted && !form?.service_type ? (
                                  <div className="invalid-feedback d-block">
                                    Service Type is Required
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            <div className="col-md-6 mb-3">
                              <label>
                                Annual Miles
                                <span className="text-danger">*</span>
                              </label>
                              <div className="input-new-design">
                                <div className="input-icon">
                                  <FaMapLocation />
                                </div>
                                <input
                                  type="text"
                                  // pattern="^[0-9]+(\.[0-9]{0,2})?$"
                                  // min={0}
                                  name=""
                                  required
                                  className="form-control"
                                  id=""
                                  value={form?.annual_miles}
                                  onChange={(e) => {
                                    setform({
                                      ...form,
                                      annual_miles: e.target.value,
                                    });
                                  }}
                                  disabled={DisbaledInput}
                                />
                                {submitted && !form?.annual_miles ? (
                                  <div className="invalid-feedback d-block">
                                    Annual Miles is Required
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </>
                        }
                        {form?.board_id == environment.rfpsId && (
                          <div className="col-md-6 mb-3">
                            <label>
                              Dispatch Days
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-calendar-day"></i>
                              </div>
                              <input
                                type="text"
                                name=""
                                className="form-control"
                                pattern="^[a-zA-Z0-9\s]*$"
                                required
                                value={form?.dispatch_days}
                                onChange={(e) => {
                                  const inputValue = e.target.value;
                                  const regex = new RegExp("^[a-zA-Z0-9\\s]*$");
                                  if (regex.test(inputValue)) {
                                    setform({
                                      ...form,
                                      dispatch_days: inputValue,
                                    });
                                  }
                                }}
                                disabled={DisbaledInput}
                              />


                              {submitted && !form.dispatch_days ? (
                                <div className="invalid-feedback d-block">
                                  Dispatch Day is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        )}
                        {form?.board_id == environment.rfpsId && (
                          <div className="col-md-6 mb-3">

                            <label>
                              All in Rate<span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-percent"></i>
                              </div>
                              <input
                                type="text"
                                name=""
                                required
                                className="form-control"
                                id=""
                                maxLength={12}
                                value={form?.all_in_rate}
                                onChange={(e) => {
                                  setform({
                                    ...form,
                                    all_in_rate: methodModel.isNumber(e),
                                  });
                                }}
                                disabled={DisbaledInput}
                              />

                              {submitted && !form.all_in_rate ? (
                                <div className="invalid-feedback d-block">
                                  All in Rate is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        )}
                        {form?.board_id == environment.rfpsId && (
                          <div className="col-md-12 mb-3">
                            <label>
                              Duration of the lane
                              <span className="text-danger">*</span>
                            </label>
                            <div className="input-new-design">
                              <div className="input-icon">
                                <i class="fas fa-calendar-day"></i>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                value={form?.lane_duration}
                                maxLength={7}
                                minLength={1}
                                required
                                onChange={(e) =>
                                  setform({
                                    ...form,
                                    lane_duration: methodModel.isNumber(e),
                                  })
                                }
                                disabled={DisbaledInput}
                              />
                              {submitted && !form.lane_duration ? (
                                <div className="invalid-feedback d-block">
                                  Lane Duration is Required
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        )}
                        {form?.board_id == environment.rfpsId && (
                          <div className="col-md-12 mb-3">
                            <label>
                              Comment
                              {/* <span className="text-danger">*</span> */}
                            </label>
                            <textarea
                              className="form-control"
                              rows={5}
                              cols={5}
                              type="text"
                              value={form?.comments}
                              onChange={(e) => {
                                setform({ ...form, comments: e.target.value });
                              }}
                            // disabled={DisbaledInput}
                            />
                          </div>
                        )}
                        {!(form?.board_id == environment.rfpsId) && (
                          <><div className="col-md-6 mb-3">
                            <label>
                              Bid Price
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              min={1}
                              className="form-control"
                              value={form?.bid_rate}
                              maxLength={7}
                              minLength={1}
                              required
                              onChange={(e) =>
                                setform({
                                  ...form,
                                  bid_rate: methodModel.isNumber(e),
                                })
                              }
                              disabled={DisbaledInput}
                            />
                            {/* {submitted && !form.bid_rate ? (
                              <div className="invalid-feedback d-block">
                                Bid Price is Required
                              </div>
                            ) : (
                              <></>
                            )} */}
                          </div>    <div className="col-md-6 mb-3">
                              <label>
                                PU Price
                                <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                min={1}
                                className="form-control"
                                value={form?.pu_rate}
                                maxLength={7}
                                minLength={1}
                                required
                                onChange={(e) =>
                                  setform({
                                    ...form,
                                    pu_rate: methodModel.isNumber(e),
                                  })
                                }
                                disabled={DisbaledInput}
                              />
                              {/* {submitted && !form.pu_rate ? (
                                <div className="invalid-feedback d-block">
                                  PU Price is Required
                                </div>
                              ) : (
                                <></>
                              )} */}
                            </div></>


                        )}

                        {!(form?.board_id == environment.rfpsId || form?.board_id == environment.contractId) && (
                          <div className="col-md-6 mb-3">
                            <label>
                              Total Distance
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={form?.total_distance}
                              maxLength={7}
                              minLength={1}
                              required
                              onChange={(e) =>
                                setform({
                                  ...form,
                                  total_distance: methodModel.isNumber(e),
                                })
                              }
                              disabled={DisbaledInput}
                            />
                            {submitted && !form.total_distance ? (
                              <div className="invalid-feedback d-block">
                                Total Distance is Required
                              </div>
                            ) : (
                              <></>
                            )}
                          </div>
                        )}

                        <div className="col-md-12 mb-3">
                          <label>Note</label>
                          <textarea
                            className="form-control"
                            rows={5}
                            cols={5}
                            type="text"
                            value={form?.notes}
                            onChange={(e) => {
                              setform({ ...form, notes: e.target.value });
                            }}
                          // disabled={DisbaledInput}
                          />
                        </div>


                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
              <div className="text-right mr-2 mb-2">
                <button type="submit" className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </Layout2>
    </>
  );
};

export default Html;
